module.exports = __webpack_public_path__ + "static/media/equals.db895548.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/images/home-page/equals.svg
// module id = 132
// module chunks = 0